import React from "react";
import { Table } from "ant-table-extensions";
import FeatherIcon from "feather-icons-react";
import { UserTableStyleWrapper } from "../../pages/style";
import { TableWrapper } from "../../styled";
import { Button } from "../../../components/buttons/buttons";
import { Cards } from "../../../components/cards/frame/cards-frame";
import { useTranslation } from "react-i18next";
import { formatSQLDate } from "../../../utils/common";
import { useHistory } from "react-router-dom";
import { DELETE_STORAGE_RECORD } from "../../../graphql/AdminMutations";
import { GET_STORAGE_SEARCH } from "../../../graphql/AdminQueries";
import displayNotification from "../../reservation/admin/notification/notification";
import { exportujDoExcelu, odkazNaAdmin } from "../../../utils/exportExcel";
import { klikNaRiadok } from "../../../utils/klikNaRiadok";
import { useMutation, useLazyQuery } from "@apollo/client";

const List = (props) => {
  const { t } = useTranslation("common");
  const {
    inputData,
    total,
    pageNumber,
    limit,
    search,
    filtreDoExportu,
    loading,
    sendPageNumberToGrid,
  } = props;

  const graphqlVariables = {
    tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
  };
  // delete storage record
  const [triggerDeleteStorageItem] = useMutation(DELETE_STORAGE_RECORD, {
    variables: graphqlVariables,
  });

  // Export tahá všetky nájdené záznamy, nie len zobrazenú stranu.
  const [nacitajNaExport, exportStav] = useLazyQuery(GET_STORAGE_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const zaznamy = data?.getStorageSearch?.records || [];
      exportujDoExcelu({
        nazovSuboru: "uskladnenia",
        nazovHarku: "Uskladnenia",
        stlpce: STLPCE_EXPORTU,
        riadky: zaznamy.map(naRiadokExportu),
        info: {
          "Hľadaný text": search || "",
          "Použité filtre": popisFiltrov(filtreDoExportu),
        },
      });
    },
    onError: () => {
      displayNotification(
        "error",
        "Export",
        "Export sa nepodarilo pripraviť, skúste to znova."
      );
    },
  });

  const onHandleDelete = (item) => {
    const confirm = window.confirm(t("backend.warehouse.delete"));
    if (confirm) {
      const variables = {
        ...graphqlVariables,
        id: parseInt(item.id),
      };

      triggerDeleteStorageItem({ variables }).then(({ data }) => {
        const response = data?.deleteStorageRecord;
        let type = "success";
        const message = t("backend.notifications.delete");
        let desc = t("backend.notifications.success.recordDelete");

        if (!response?.sucessful) {
          type = "error";
          desc = t("backend.notifications.error.recordDelete");
          displayNotification(type, message, desc);
        } else {
          displayNotification(type, message, desc);
          setTimeout(function() {
            window.location.replace("/admin/service/warehouse");
          }, 3000);
        }
      });
    }
  };

  const history = useHistory();

  const routeChange = (item) => {
    const detailPath = `/admin/service/warehouse-item/${item.id}`;
    history.push(detailPath);
  };

  // Zobrazujeme všetky uskladnenky všetkých pobočiek, aj viac záznamov
  // k jednému vozidlu. Predtým sa ukazoval len posledný záznam auta.
  const tableData = (inputData || []).map((item) => {
    const { id, car } = item;
    const link = "/admin/car/edit/" + car?.id;
    return {
      key: id,
      licence_plate: (
        <a key={id} href={link}>
          <span className={`status-text`}>{car?.licence_plate}</span>
        </a>
      ),
      branchOffice: car?.branchOffice?.company,
      carOwner: car?.carOwner?.company,
      carRenter: car?.carRenter?.company,
      date: formatSQLDate(item.date),
      number: item.number,
      thread: item?.thread,
      tyreBrand: item?.tyre_brand,
      diskType: item?.disk_type,
      season: item?.season,
      zaznam: item,
      action: (
        <div className="table-actions" onClick={(e) => e.stopPropagation()}>
          <>
            <Button
              onClick={() => routeChange(item)}
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
              title="Upraviť uskladnenie"
            >
              <FeatherIcon icon="edit" size={16} />
            </Button>
            <Button
              onClick={() => onHandleDelete(item)}
              className="btn-icon"
              type="info"
              to="#"
              shape="circle"
            >
              <FeatherIcon icon="trash-2" size={16} />
            </Button>
          </>
        </div>
      ),
    };
  });

  const STLPCE_EXPORTU = [
    { kluc: "ecv", popis: "EČV", sirka: 14, typ: "odkaz" },
    { kluc: "vin", popis: "VIN", sirka: 20 },
    { kluc: "vozidlo", popis: "Vozidlo", sirka: 28 },
    { kluc: "cislo", popis: "Č. uskladnenia", sirka: 16 },
    { kluc: "datum", popis: "Dátum", sirka: 12, typ: "datum" },
    { kluc: "pneuservis", popis: "Pneuservis", sirka: 20 },
    { kluc: "majitel", popis: "Majiteľ", sirka: 28 },
    { kluc: "najomca", popis: "Nájomca", sirka: 28 },
    { kluc: "dezen", popis: "Hĺbka dezénu", sirka: 14 },
    { kluc: "pneu", popis: "PNEU", sirka: 24 },
    { kluc: "rozmer", popis: "Rozmer", sirka: 16 },
    { kluc: "disk", popis: "Disk", sirka: 12 },
    { kluc: "sezona", popis: "Sezóna", sirka: 10 },
    { kluc: "kusov", popis: "Kusov", sirka: 8, typ: "cislo" },
  ];

  const naRiadokExportu = (item) => {
    const car = item?.car;
    return {
      ecv: {
        text: car?.licence_plate || "",
        url: car?.id ? odkazNaAdmin(`/admin/car/edit/${car.id}`) : null,
      },
      vin: car?.vin,
      vozidlo: car?.type,
      cislo: item?.number,
      datum: item?.date,
      pneuservis: car?.branchOffice?.company,
      majitel: car?.carOwner?.company,
      najomca: car?.carRenter?.company,
      dezen: item?.thread,
      pneu: item?.tyre_brand,
      rozmer: item?.size,
      disk: item?.disk_type,
      sezona: item?.season,
      kusov: item?.qty,
    };
  };

  const popisFiltrov = (f) => {
    const casti = [];
    if (f?.branchOfficeId) casti.push("pneuservis");
    if (f?.carOwnerId) casti.push("majiteľ");
    if (f?.carRenterId) casti.push("nájomca");
    if (f?.season) casti.push(`sezóna ${f.season}`);
    if (f?.diskType) casti.push(`disk ${f.diskType}`);
    if (f?.dateFrom || f?.dateTo)
      casti.push(`dátum ${f.dateFrom || "…"} až ${f.dateTo || "…"}`);
    return casti.length ? casti.join(", ") : "žiadne";
  };

  const handleDownload = () => {
    nacitajNaExport({
      variables: {
        ...(filtreDoExportu || {}),
        tokenGet: process.env.REACT_APP_TOKEN_GET,
        search: search || undefined,
        limit: 0,
        offset: 0,
      },
    });
  };

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        <Button
          className="btn-export"
          onClick={handleDownload}
          type="primary"
          disabled={exportStav?.loading}
        >
          {exportStav?.loading ? "Pripravujem export..." : "Export do Excelu"}
        </Button>
        <TableWrapper className="table-responsive">
          <Table
            scroll={{ x: "max-content" }}
            dataSource={tableData}
            columns={getTableColumns(t)}
            loading={loading}
            rowClassName={() => "riadok-klikatelny"}
            onRow={(record) =>
              klikNaRiadok({
                cesta: `/admin/service/warehouse-item/${record?.zaznam?.id}`,
                akcia: () => record?.zaznam && routeChange(record.zaznam),
              })
            }
            pagination={{
              pageSize: limit || 20,
              total: total || 0,
              current: pageNumber || 1,
              showSizeChanger: true,
              pageSizeOptions: ["20", "50", "100", "200"],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items"
                )}`,
              position: ["topLeft", "bottomLeft"],
            }}
            onChange={(pagination) => {
              if (typeof sendPageNumberToGrid === "function") {
                sendPageNumberToGrid({
                  pageNumber: pagination.current,
                  pageSize: pagination.pageSize,
                });
              }
            }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
    </Cards>
  );
};

const getTableColumns = (t) => {
  return [
    {
      title: t("serviceActions.tableList.licencePlate"),
      dataIndex: "licence_plate",
      key: "licence_plate",
    },
    {
      title: t("backend.warehouse.number"),
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Dátum",
      dataIndex: "date",
      key: "date",
    },
    {
      title: t("common.pneuservice"),
      dataIndex: "branchOffice",
      key: "branchOffice",
    },
    {
      title: t("serviceActions.tableList.carOwner"),
      dataIndex: "carOwner",
      key: "carOwner",
    },
    {
      title: t("serviceActions.tableList.carRenter"),
      dataIndex: "carRenter",
      key: "carRenter",
    },
    {
      title: t("backend.warehouse.thread"),
      dataIndex: "thread",
      key: "thread",
    },
    {
      title: "PNEU",
      dataIndex: "tyreBrand",
      key: "tyreBrand",
    },
    {
      title: t("backend.warehouse.diskType"),
      dataIndex: "diskType",
      key: "diskType",
    },
    {
      title: t("backend.warehouse.season"),
      dataIndex: "season",
      key: "season",
    },
    {
      title: t("common.actions"),
      dataIndex: "action",
      key: "action",
      width: "90px",
    },
  ];
};

export default List;
